import { render, staticRenderFns } from "./dataViewTable.vue?vue&type=template&id=b95972e4&scoped=true&"
import script from "./dataViewTable.vue?vue&type=script&lang=js&"
export * from "./dataViewTable.vue?vue&type=script&lang=js&"
import style0 from "./dataViewTable.vue?vue&type=style&index=0&id=b95972e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95972e4",
  null
  
)

export default component.exports